import React, { useContext, useEffect, useState } from 'react';

import { TPeriod } from '@r1-frontend/ui-react/components/costs/PurchaseOptions/types';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import RouterCard from '@r1-frontend/ui-react/organisms/Card/Router';

import addEntity from '~/src/features/tariffBuilder/actions/addEntity';
import decrementEntity from '~/src/features/tariffBuilder/actions/decrementEntity';
import incrementEntity from '~/src/features/tariffBuilder/actions/incrementEntity';
import { useConstructorAnalytics } from '~/src/features/tariffBuilder/analytics/hooks/useConstructorAnalytics';
import EquipmentCharacteristics from '~/src/features/tariffBuilder/components/EquipmentCharacteristics';
import EquipmentImages from '~/src/features/tariffBuilder/components/EquipmentImages';
import { BasePopupWithScroll, TheScrollbar } from '~/src/features/tariffBuilder/components/popups/BasePopupWithScroll';
import MaximumTotalLimit from '~/src/features/tariffBuilder/components/toast/MaximumTotalLimit';
import PurchaseOptionsContainer from '~/src/features/tariffBuilder/containers/PurchaseOptionsContainer';
import { Ctx } from '~/src/features/tariffBuilder/Ctx';
import { useCtxDispatch, useCtxSelector } from '~/src/features/tariffBuilder/hooks';
import { getRouterById } from '~/src/features/tariffBuilder/selectors/getRouterById';
import getRouters from '~/src/features/tariffBuilder/selectors/getRouters';
import isLimitationsReached from '~/src/features/tariffBuilder/selectors/isLimitationsReached';
import isSelectedRouterInCurrentTariff from '~/src/features/tariffBuilder/selectors/isSelectedRouterInCurrentTariff';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

// @todo merge with same others Routers|Decoders|Entities|TvSubscriptions(Container)
type TOwnState = {
    selectedId: undefined,
    isPopupOpen: false,
} | {
    selectedId: number,
    isPopupOpen: true,
}

const RoutersContainer = (): JSX.Element => {

    const [{ selectedId, isPopupOpen }, setState] = useState<TOwnState>({
        selectedId: undefined,
        isPopupOpen: false,
    });

    const { limitations, routers, hasRouterInCurrentTariff } = useCtxSelector(state => ({
        limitations: isLimitationsReached(EEntity.routers)(state),
        routers: getRouters(state),
        // TODO - когда биллинг будет готов принимать массив, удалить.
        hasRouterInCurrentTariff: isSelectedRouterInCurrentTariff(state),
    }));
    const selectedRouter = useCtxSelector(getRouterById(selectedId));
    const dispatch = useCtxDispatch();
    const { toaster } = useContext(Ctx);

    const analytics = useConstructorAnalytics();

    useEffect(() => {
        if (limitations.total) {
            toaster.add(<MaximumTotalLimit equipmentName={'роутеров'}/>);
        }
    }, [limitations.total]);

    const handleAdd = (key: number) => () => {
        const currentRouter = routers.find(el => el.key === key);

        setState(prev => ({ ...prev, selectedId: key, isPopupOpen: true }));
        analytics.clickedAddProduct({ type: 'router', title: `${currentRouter?.title}` });
    };

    const handleIncrement = (key: number) => () => {
        dispatch(incrementEntity({
            entity: EEntity.routers,
            key,
        }));
    };
    const handleDecrement = (key: number) => () => {
        dispatch(decrementEntity({
            entity: EEntity.routers,
            key,
        }));
    };

    const handleClosePopup = () => {
        setState(prev => ({ ...prev, selectedId: undefined, isPopupOpen: false }));
    };

    const handleSelectPurchaseOption = (key: number) => (cost: number, period: TPeriod) => {
        const currentRouter = routers.find(el => el.key === key);
        dispatch(addEntity({
            entity: EEntity.routers,
            key,
            period,
            cost,
            title: `${currentRouter?.title}`,
        },
        analytics));
        handleClosePopup();
    };

    return (
        <>
            <ListContainer $desktop={16} $mobile={12} $direction={'row'} $wrap={'wrap'}>
                {routers.map(({ key, ...router }) => <RouterCard
                    key={`RouterEntity_${router.id}`}
                    {...router}
                    labels={[]}
                    onButtonClick={handleAdd(key)}
                    onIncrement={handleIncrement(key)}
                    onDecrement={handleDecrement(key)}
                    onCostClick={handleAdd(key)}
                    disabled={hasRouterInCurrentTariff || (limitations.total || (router.displayedCost > 1 && limitations.installment))}
                />)}
            </ListContainer>

            {(isPopupOpen && selectedId && selectedRouter) &&
                <BasePopupWithScroll
                    isOpen={true}
                    onClose={handleClosePopup}
                >
                    <H3>{selectedRouter.title}</H3>

                    <TheScrollbar>
                        <EquipmentImages
                            images={selectedRouter.images}
                        />
                        <EquipmentCharacteristics
                            characteristics={selectedRouter.characteristics}
                        />
                        <PurchaseOptionsContainer
                            entityName={EEntity.routers}
                            id={selectedId}
                            onSelect={handleSelectPurchaseOption(selectedId)}
                        />
                    </TheScrollbar>
                </BasePopupWithScroll>
            }
        </>
    );
};

export default RoutersContainer;
